/**
 * Every toggleable sidebar function, in nav order, with the section it lives
 * under. The demo shows the subset an admin ticks in Settings (the "Demo
 * navigation" matrix); the demo's AppShell filters its nav to that set. Kept in
 * one place so the matrix and the demo filter can never disagree about what the
 * functions are. Keep this in step with NAV_SECTIONS in App.tsx.
 */
export interface NavFunction {
  to: string;
  label: string;
  section: string;
}

export const NAV_FUNCTIONS: NavFunction[] = [
  { to: '/live', label: 'Live', section: 'Monitor' },
  { to: '/dashboard', label: 'Dashboard', section: 'Monitor' },
  { to: '/history', label: 'History', section: 'Monitor' },
  { to: '/reporting', label: 'Reporting', section: 'Monitor' },
  { to: '/safety', label: 'Safety', section: 'Monitor' },
  { to: '/safety/live', label: 'Live safety', section: 'Monitor' },
  { to: '/dataset', label: 'Dataset', section: 'Inspection' },
  { to: '/annotate', label: 'Annotate', section: 'Inspection' },
  { to: '/labels', label: 'Etiket AI', section: 'Inspection' },
  { to: '/classify', label: 'Classify', section: 'Inspection' },
  { to: '/classes', label: 'Classes', section: 'Inspection' },
  { to: '/confusion', label: 'Confusion', section: 'Inspection' },
  { to: '/training', label: 'Training', section: 'Inspection' },
  { to: '/gpu', label: 'Cloud GPU', section: 'Inspection' },
  { to: '/model-analytics', label: 'Model analytics', section: 'Inspection' },
  { to: '/proposals', label: 'Proposals', section: 'Equipment' },
  { to: '/line', label: 'Line', section: 'Equipment' },
  { to: '/fleet', label: 'Fleet', section: 'Equipment' },
  { to: '/customers', label: 'Customers', section: 'Admin' },
  { to: '/website', label: 'Website', section: 'Admin' },
  { to: '/analytics', label: 'Analytics', section: 'Admin' },
  { to: '/users', label: 'Users', section: 'Admin' },
  { to: '/settings', label: 'Settings', section: 'Admin' },
];

/** What the demo shows until an admin says otherwise (the tenant-facing set). */
export const DEFAULT_DEMO_NAV = ['/live', '/dashboard', '/history', '/reporting', '/safety', '/safety/live'];
